module.exports = __webpack_public_path__ + "img/product_125.1eb59f3.svg";